import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import I18n from 'I18n';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UIScreenReaderOnly from 'UIComponents/text/UIScreenReaderOnly';
import UniversalAssociationsSelectSideNavAccessibilityMessage from './UniversalAssociationsSelectSideNavAccessibilityMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UniversalAssociationsSelectSideAllAssociationsNavItem = ({
  allAssociationsCount,
  selectedObjectTypeId,
  onSetSelectedObjectTypeId
}) => {
  const selectedAssociationsLabel = I18n.text('universalAssociationsSelect.selectedAssociationsLabel');
  const handleSelectNavItem = () => onSetSelectedObjectTypeId(undefined);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UISideNavItem, {
      "data-test-id": 'universal-associations-select-nav-item-all-associations',
      "data-selenium-test": "association-nav",
      "data-selenium-value": selectedAssociationsLabel,
      "aria-describedby": 'universal-associations-select-nav-item-all-associations',
      title: /*#__PURE__*/_jsx(UITruncateString, {
        children: selectedAssociationsLabel
      }),
      active: !selectedObjectTypeId,
      count: allAssociationsCount,
      onClick: handleSelectNavItem
    }), /*#__PURE__*/_jsx(UIScreenReaderOnly, {
      children: /*#__PURE__*/_jsx("div", {
        id: 'universal-associations-select-nav-item-all-associations',
        children: /*#__PURE__*/_jsx(UniversalAssociationsSelectSideNavAccessibilityMessage, {
          pluralObjectName: selectedAssociationsLabel,
          count: allAssociationsCount
        })
      })
    })]
  });
};
export default UniversalAssociationsSelectSideAllAssociationsNavItem;